'use client';

import { ContentErrorView } from '@northladder/design-system';
import { useTranslations } from '@northladder/i18n';

/**
 * -----------------------------------------------------------------------------
 * UI shown when the evaluation id is deemed invalid.
 */
export function InvalidSession() {
  const t = useTranslations('invalidEvaluationId');

  return <ContentErrorView subTitle={t('subTitle')} title={t('title')} />;
}
